import script from "./WindyLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WindyLayer.vue?vue&type=script&setup=true&lang=ts"

import "./WindyLayer.vue?vue&type=style&index=0&id=259b834c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259b834c"]])

export default __exports__